import breakpointObj from 'styles/breakpoints.module.scss';

const breakpoints = Object.entries(breakpointObj).reduce((acc, cur) => {
  acc[cur[0]] = Number(cur[1].replace('px', ''));
  return acc;
}, {} as Record<string, number>);

export default breakpoints;
